module.exports = __webpack_public_path__ + "static/media/swingintime1.db718fdb.jpg";